import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  idFrom:"",
  idTo:"",
  defaultStoreIdFrom:"",
  defaultStoreIdTo:"",
  useraccountIdFrom:"",
  useraccountIdTo:"",
  numberNTrom:"",
  numberNTTo:"",
  dateContractFrom:null,
  dateContractTo:null,
  ori_tras_store_idFrom: "", 
  ori_tras_store_idTo: "", 
  dest_tras_store_idFrom:"",
  dest_tras_store_idTo:"",
};

const filtersContractsSlice = createSlice({
  name: 'filtersContracts',
  initialState,
  reducers: {
    setFilters(state, action) {
      return { ...state, ...action.payload };
    },
    resetFilters() {
      return initialState;
    },
  },
});

export const { setFilters, resetFilters } = filtersContractsSlice.actions;
export default filtersContractsSlice.reducer;
